import { defineStore } from 'pinia'
import api from '@/api'

/** ユーザーハッシュを保存するローカルストレージのキー */
const USER_HASH_LOCAL_STORAGE_KEY = 'userHash'

export const useUserStore = defineStore({
  id: 'user',
  state: (): {
    /** ユーザーハッシュ */
    hash: string | null
    /** ユーザーデータ。null のときはログインしていない */
    data: { userName: string; userSect: string } | null
    /** ログアウトした（直後）か否か */
    loggedOutData: { userName: string; userSect: string } | null
  } => ({
    hash: null,
    data: null,
    loggedOutData: null,
  }),
  getters: {},
  actions: {
    /** ユーザーハッシュをローカルストレージとストアへ保存する */
    async storeHash(hash: string) {
      localStorage.setItem(USER_HASH_LOCAL_STORAGE_KEY, hash)
      this.hash = hash
    },
    /** ユーザーハッシュをローカルストレージからストアへ保存する */
    async fetchHash() {
      this.hash = localStorage.getItem(USER_HASH_LOCAL_STORAGE_KEY)
    },
    /** ユーザーハッシュをローカルストレージとストアから削除する */
    async clearHash() {
      localStorage.removeItem(USER_HASH_LOCAL_STORAGE_KEY)
      this.hash = null
    },
    /** ユーザーデータをフェッチしてストアへ保存する */
    async fetchUser() {
      if (!this.hash) {
        this.data = null
      } else {
        await api.user
          .get({ cd: this.hash })
          .then(user => {
            this.data = user
          })
          .catch(() => {
            this.data = null
          })
      }
    },
    /**
     * ユーザーハッシュ`hash`とユーザーデータ`data`を全て削除する
     *
     * loggedOutDataは削除しない。
     */
    async clear() {
      await this.clearHash()
      this.data = null
    },
  },
})
